import { useAsset } from "../../AssetHelper";

import './OneThird.css'
import ScrollingText from "../components/ScrollingText";
import { ReactNode, useContext } from "react";
import DisplayParams from "../DisplayParams";
import { t } from "../../i18n";
import {ReactSVG} from "react-svg";
import EventName from "../components/EventName";

export default function OneThird({matchName, vflip, children} : {
    matchName: ReactNode,
    vflip: boolean,
    children: ReactNode
}) {
    const displayParams = useContext(DisplayParams);
    const themeLogo = useAsset(displayParams.isFirstChampionship ? "img/logos/decode_fcmp_onecolor.svg" : "img/logos/decode_season_global_wide.svg")
    const gameLogo = useAsset(`img/logos/decode_season_primary_wide${displayParams.alternatePresentingSponsor ? '_' + displayParams.alternatePresentingSponsor : ''}.svg`)
    const name = <ScrollingText><EventName invertLogo /></ScrollingText>;

    return <div className={`oneThirdContainer ${vflip ? "vflip" : ""} ${displayParams.isFirstChampionship ? 'fcmp' : ''}`}>
        <div className="titleBar">
            {themeLogo ? <div className={"themeLogoWrapper"}>
                  <img className="themeLogo" src={themeLogo}/>
            </div>: null}
            <div className="eventName text">{name}</div>
            <div className="bar"></div>
            <div className="matchName text">{matchName}</div>
            {gameLogo ? <div className={"gameLogoWrapper"}>
              <img className="gameLogo" src={gameLogo}/>
            </div>: null }
        </div>
        <div className="overlayContent">
            {children}
        </div>
    </div>
}